/** Visible facility rows before the table body scrolls inside its card. */
export const NETWORK_FACILITY_TABLE_VISIBLE_ROWS = 10;

const NETWORK_FACILITY_TABLE_ROW_HEIGHT_PX = 52;
const NETWORK_FACILITY_TABLE_HEADER_HEIGHT_PX = 41;

/** Max scroll container height (px) when row count exceeds the visible limit. */
export function getNetworkFacilityTableMaxHeight(rowCount: number): number | undefined {
  if (rowCount <= NETWORK_FACILITY_TABLE_VISIBLE_ROWS) return undefined;
  return (
    NETWORK_FACILITY_TABLE_HEADER_HEIGHT_PX +
    NETWORK_FACILITY_TABLE_VISIBLE_ROWS * NETWORK_FACILITY_TABLE_ROW_HEIGHT_PX
  );
}
